import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';

import Loader from '../Loader/Loader';

import { closeDeleteUserModal } from '../../actions/modalActions';
import { deleteUser } from '../../actions/siteadmin/users';

import cx from 'classnames';
import bt from '../../components/commonStyle.css';
import s from './DeleteUserForm.css';

import messages from '../../locale/messages';

const DeleteUserModal = () => {

    const dispatch = useDispatch();
    const { formatMessage } = useIntl();

    const [isLoading, setIsLoading] = useState(false);
    const openDeleteModal = useSelector(state => state?.modalStatus?.openDeleteModal);
    const userId = useSelector(state => state?.account?.data?.userId);

    const handleClick = async (userId) => {
        setIsLoading(true);
        await dispatch(deleteUser(userId));
        setIsLoading(false);
    };


    return (

        <Modal show={openDeleteModal} onHide={() => dispatch(closeDeleteUserModal())} dialogClassName={'loginModal'} >
            <Modal.Header closeButton>
                <Modal.Title><FormattedMessage {...messages.deleteAccount} /></Modal.Title>
            </Modal.Header>
            <Modal.Body bsClass={s.logInModalBody}>
                <div className={s.root}>
                    <div className={s.modalContent}>
                        <FormattedMessage {...messages.areYouSureDeleteAccount} />
                    </div>
                    <div className={s.deleteButtonContainer}>
                        <Button
                            onClick={() => dispatch(closeDeleteUserModal())} className={cx(bt.btnPrimaryBorder)}>
                            <FormattedMessage {...messages.cancel} />
                        </Button>
                        <Loader
                            type={"button"}
                            buttonType={"button"}
                            show={isLoading}
                            label={formatMessage(messages.proceed)}
                            handleClick={() => { handleClick(userId) }}
                            className={cx(bt.btnPrimary, 'commonLoaderFlex')}
                        />
                    </div>
                </div>
            </Modal.Body>
        </Modal>

    )
}

DeleteUserModal.propTypes = {
    deleteUser: PropTypes.any,
    userId: PropTypes.string
};

export default withStyles(s, bt)(DeleteUserModal);
